import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, Table } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import DeleteModal from '../../components/DeleteModal';
import OptionsView from '../../components/options/OptionsView';
import EditOption from '../../components/options/EditOption';
import AddOption from '../../components/options/AddOption';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import { useGlobalState } from '../../context/GlobalStateContext';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';

function Options() {
    const [options, setOptions] = useState([])

    const { loading, setLoading, search, pagination, setPagination, handleSearch, handleLimitChange } = useGlobalState()


    const fetchOptions = useCallback(async (page = 1, limit = 10, searchQuery = '') => {
        try {
            setLoading(true)
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/option/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery
                }
            })
            if (response.data.success) {
                setOptions(response.data.data);
                setPagination(response.data.pagination);
            }
            else {
                setOptions([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
            setOptions([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
        }
        finally {
            setLoading(false)
        }
    }, [setLoading, setPagination])
    const handleDelete = async (id) => {
        try {
            setLoading(true);
            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/option/delete/${id}`);
            if (response.data.success) {
                CustomToast.success(response.data.message);
                fetchOptions(pagination.currentPage, pagination.limit, search);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchOptions(pagination.currentPage, pagination.limit, search);
    }, [pagination.currentPage, pagination.limit, search, fetchOptions])


    return (
        <Layout title="Options List">
            <main>
                <div className="card page-card">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <p>Show</p>
                            <Form.Select aria-label="Default select example" value={pagination.limit} onChange={handleLimitChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </Form.Select>
                            <p>entries</p>
                        </div>

                        <div className='d-flex flex-column flex-md-row  align-items-start align-items-md-center gap-3 sm-w-100'>
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>
                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchOptions)}
                                    />
                                </InputGroup>
                            </div>

                            <AddOption onOptionAdded={() => fetchOptions(1, pagination.limit, search)} />
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table className='vertical-align'>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th>Created Date</th>
                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (<tr>
                                        <td colSpan="7" className="text-center">
                                            <Loader />
                                        </td>
                                    </tr>)
                                        : options.length > 0 ? (
                                            options.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td><p className='mb-0'>{(pagination.currentPage - 1) * pagination.limit + index + 1}</p></td>
                                                    <td className='table-td-200'>{item.name}</td>
                                                    <td className='table-td-130'>{item.createdAt ? new Date(item.createdAt).toISOString().split('T')[0] : ""}</td>
                                                    <td>
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <OptionsView option={item} />
                                                            <EditOption onOptionAdded={() => fetchOptions(1, pagination.limit, search)} id={item._id} />
                                                            <DeleteModal
                                                                onConfirm={() => handleDelete(item._id)}
                                                                loading={loading}
                                                                flag={"option"}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))) : (
                                            <tr>
                                                <td colSpan="10" className="text-center">
                                                    <NoDateFound />
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </Table>
                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalItems}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                        />
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default Options